import { extVideoEndPoint } from "../../pages/loader/variables";

export const initialHPTVariants = {
    initial: (i) => ({
        transform: i[0] ? "translate3d(0, 105%, 0)" : "translate3d(0,0,0)"
    }), animate: (i) => ({
        transform: "translate3d(0,0,0)",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1],
            delay: i[3] && !i[4] ? extVideoEndPoint -0.5 : i[0] ? 0.15 + 0.05 * i[1] : 0
        }
    }), exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: 0.75,
            delay: i[2] * 0.05,
            ease: [0.7, 0, 0.84, 0]
        }
    })
}